<template>
  <div class="container">
    <el-dialog
      append-to-body
      title="编辑"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
    >
    <el-form :inline="true">
        <el-form-item>
        <el-input v-model="name" placeholder="名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #activity_time="{ row }">
        <div>
          <p>开始:{{ row.start_time }}</p>
          <p>结束:{{ row.end_time }}</p>
        </div>
      </template>
      <template #status="{ row }">
        <div>
          <el-tag type="info" size="small" v-if="row.status === 1">待审核</el-tag>
          <el-tag type="success" size="small" v-if="row.status === 2"
            >通过</el-tag
          >
           <el-tag type="danger" size="small" v-if="row.status === 3"
            >审核拒绝</el-tag
          >
           <el-tag type="danger" size="small" v-if="row.status === 4"
            >冻结</el-tag
          >
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button type="primary" size="small" @click="bindVenue(row)"
            >绑定场地</el-button
          >
        </div>
      </template>
    </auto-table>
</el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      DataList: [],
      Option: [
        { name: "名称", value: "name" },
        { name: "城市", value: "city" },
        { name: "状态", value: "status", type: "custom" },
        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: "",
      name: "",
      dialogVisible: false,
      card:{}
    };
  },

  methods: {
    open(card) {
        this.card = card
      this.dialogVisible = true;
    },
    toScheduling(row) {
      this.$router.push({ name: "serviceScheduling", query: { vid: row.id } });
    },
    details(row) {
      this.$router.push({ name: "sharedVenueDetail", query: { id: row.id } });
    },
    addNew() {
      this.$refs.add.open();
    },

    updateInfo(row) {
      this.$refs.add.open(row);
    },
    bindVenue(row) {
        let data = {
            card_id: this.card.id,
            mechanism_id: row.mechanism_id,
           venue_id: row.id,
           venue_name: row.name
        }
      this.$post("/user/cardBindMechanism/insert", data).then(
        (res) => {
          this.$message("成功");
          this.getList(1);
        }
      );
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/shared/sharedVenue/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          status: 2,
          name: this.name || null,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>